import { use } from "react";
import { AuthManagerContext } from "../contexts/AuthManager";
import { useGetIsWorkerProfileComplete } from "./use-get-is-worker-profile-complete";

export const usePostOnboardingData = () => {
    const { user } = use(AuthManagerContext);
    const getIsWorkerProfileComplete = useGetIsWorkerProfileComplete();

    return getIsWorkerProfileComplete(user);
};
